<script>
export default {
	name: 'SubsidyMadaniFirefly',
};
</script>

<script setup>
import BookFlight from '~/components/firefly/BookingWidget/FlightSearch/BookFlight.vue';
import { i18nGlobal } from '~/logic/i18n.js';
const props = defineProps({
	hideTodayDateIndicator: { type: Boolean, default: false },
	subHeaderTabDescription: { type: String, default: '' },
	subHeaderTabTooltipBody: { type: String, default: '' },
	subHeaderTabTooltipLabel: { type: String, default: '' },
	note: { type: String, default: '' },
	searchFlightCTAText: { type: String, default: i18nGlobal.t('Search flight') },

	ondSelection: { type: Object, default: null },
	datePicker: { type: Object, default: null },
	passengerSelection: { type: Object, default: null },
	promoCodeLabel: { type: String, default: null },
	promoCodeErrorMessage: { type: String, default: i18nGlobal.t('Conditions not met for promo code to be applied') },
	supersedePromoCode: { type: String, default: null },

	bstNoteTop: { type: String, default: '' },
	bstNoteCTAText: { type: String, default: '' },
	bstNoteCTAURL: { type: String, default: '' },

	subHeaderTooltipCTATextMobileLabel: { type: String, default: '' },
	fromQuestionMobile: { type: String, default: '' },
	toQuestionMobile: { type: String, default: '' },
	datePickerQuestionMobile: { type: String, default: '' },
	passengerSelectionQuestion: { type: String, default: '' },
	flightSearchApiUrl: { type: String, default: '' },
	madaniFormTargetUrl: { type: String, default: '' },
	cabinClassCashList: { type: Array, default: () => [] },
	cabinClassMilesList: { type: Array, default: () => [] },

	togglePointsApiURL: { type: String, default: '' },

	enableMattaToggleButton: { type: Boolean, default: false },
	mattaToggleButtonLabel: { type: String, default: '' },

	hideEnrichToggle: { type: Boolean, default: false },
	hidePromoCodeField: { type: Boolean, default: false },
	
	enrichAlwaysOn: { type: Boolean, default: false },

	enrichAlwaysOnCountriesData: { type: Array, default: () => [] },

	loggedInMessageNote: { type: String, default: '' },
	nonLoggedInMessageNote: { type: String, default: '' },

	currencyLabel: { type: String, default: '' },
	defaultCurrency: { type: String, default: '' },

	isMadaniSubsidy: { type: Boolean, default: false },

	componentIdAA: { type: String, default: '' },
});
const emit = defineEmits([
	// 'update:modelValue',
]);

</script>

<template>
<div class="SubsidyMadaniFirefly">
	<BookFlight
		ref="subsidyMadaniFireflyEl"
		:hideTodayDateIndicator="props.todayIndicator"
		:subHeaderTabDescription="props.subHeaderTabDescription"
		:subHeaderTabTooltipBody="props.subHeaderTabTooltipBody"
		:subHeaderTabTooltipLabel="props.subHeaderTabTooltipLabel"
		:note="props.note"
		:searchFlightCTAText="props.searchFlightCTAText"
		:ondSelection="props.ondSelection"
		:datePicker="props.datePicker"
		:hidePromoCodeField="props.hidePromoCodeField"
		:promoCodeLabel="props.promoCodeLabel"
		:promoCodeErrorMessage="props.promoCodeErrorMessage"
		:supersedePromoCode="props.supersedePromoCode?.trim()"
		:passengerSelection="props.passengerSelection"
		:subHeaderTooltipCTATextMobileLabel="props.subHeaderTooltipCTATextMobileLabel"
		:fromQuestionMobile="props.fromQuestionMobile"
		:toQuestionMobile="props.toQuestionMobile"
		:flightSearchApiUrl="props.flightSearchApiUrl"
		:currencyLabel="props.currencyLabel"
		:defaultCurrency="props.defaultCurrency"
		:isMadaniSubsidy="true"
		:madaniFormTargetUrl="props.madaniFormTargetUrl"
		:componentIdAA="props.componentIdAA"
	/>
</div>
</template>


<style scoped lang="scss">
@use 'sass:color';
@use '~/styles/partials/_var.scss';

.SubsidyMadaniFirefly {
	
}

</style>
